import React from 'react'
import { Card, Col, Row, Typography, Icon, Spin, Tag } from 'antd';
import news1 from '../../../assets/images/news/news1-n.jpg'
import Lines from 'react-lines-ellipsis'
import { changeFormatdate } from '../../../utils/formatdate'
import {
    BrowserRouter as Router,
    Link,
    Route
} from 'react-router-dom'
import moment from 'moment'
import {decodeBase64} from '../../../utils/base64File'



const { Meta } = Card;
const { Text, Title } = Typography
class BoxNews extends React.PureComponent {

    checkStatus = (value) =>{
        if(value == 'PUBLIC'){
            return <>
                        <Icon type="global" className="mr-2" />
                        สาธารณะ
                    </>
        }else if(value == 'INTERNAL'){
            return  <>
                        <Icon type="team" className="mr-2" />
                        ภายใน
                    </>
        }else if(value == 'PRIVATE'){
            return 'ยังไม่เผยแพร่'
        }
    }

    renderBox = (detailBox, limit) => {
        const { pathLink } = this.props
        // console.log(limit);
        let readmoreText = "อ่านต่อ >>";
        let collumn = 8
        if (limit == 1) {
            collumn = 24
        }
        // console.log('detailBox',detailBox)
        return (
            detailBox = detailBox.map(headpost => (
                <Link
                    to={{
                        pathname: '/'+pathLink+'/detailnews/'+headpost.postId,
                    }}>
                    <Col span={collumn}>
                        <div className="uiMediaThumb">
                            {
                                //pendtest
                                headpost.fileData &&
                                <i className="uiMediaThumbImg" style={{ backgroundImage:"url(data:"+headpost.fileData.fileMimeType+"/gif;base64,"+headpost.fileData.fileId+")", }}></i>
                            }
                            {/* {
                                //produtionsWeb
                                headpost.bannerLink &&
                                <i className="uiMediaThumbImg" style={{ backgroundImage:"url("+headpost.bannerLink+")", }}></i>
                            } */}
                        </div>
                        <Card
                            hoverable
                            className="border-crad-custom"
                        >
                            <Row >
                                <Col className="gutter-row" span={24}>
                                    <Title level={4} style={{ marginBottom: '5px' }}>
                                        <Lines
                                            text={headpost.postTitleTH}
                                            maxLine='1'
                                            ellipsis='...'
                                            trimRight
                                            baseOn='letters'
                                            style={{ color:"#6b3432" }}
                                        />
                                    </Title>
                                    <Tag className="color-white" style={{ backgroundColor:"#f1b341",border:"0" }}>{ this.checkStatus(headpost.status) }</Tag>
                                </Col>
                                <Col className="gutter-row" span={24}>
                                    <div className="color-orange" >

                                    </div>
                                </Col>
                                <Col className="gutter-row" span={24} className="my-4">
                                    <Lines
                                        text={headpost.subTitleTH}
                                        maxLine='2'
                                        ellipsis='...'
                                        trimRight
                                        baseOn='letters'
                                        style={{ color:"#9c9c9c" }}
                                    />
                                </Col>
                                <Col className="mb-3 pt-1">
                                    {
                                        headpost.division &&
                                        <p style={{ fontSize:"10px", lineHeight:"1.3" }}>ประกาศโดย : { headpost.division }</p>
                                    }
                                </Col>
                                <div className="mb-2">
                                    <Text style={{ fontSize: 12, color:"#9c9c9c" }} >{changeFormatdate(headpost.updatedAt)}{moment(headpost.updatedAt).format(' | เวลา HH:mm น.')}</Text><br />
                                    <Text style={{ fontSize: 12, color:"#9c9c9c" }} >จำนวนผู้อ่าน { headpost.readPost } คน</Text>
                                </div>
                                <Text className="color-orange" >{readmoreText}</Text>
                            </Row>
                        </Card>
                    </Col>
                </Link>
            ))
        )
    }

    render() {
        const { picnews, detailBox, limit } = this.props
        console.log('detailBox', detailBox)
        return (
            <div className="site-card-wrapper">
                {detailBox.fetchListPost &&
                    <Row gutter={16}>
                        {this.renderBox(detailBox.fetchListPost.data, limit)}
                    </Row>
                    ||
                    <>
                        {/* <Spin style={{ marginLeft: '50%' }} /> */}

                        <div style={{textAlign:"center"}}>
                            <Text className="color-gray" >ไม่พบข้อมูล</Text>
                        </div>
                        <hr className="mt-4" />
                    </>
                }
            </div>
        )
    }
}

export default BoxNews